<template>
  <section class="grid gap-6 lg:grid-cols-3">
    <div class="space-y-6 lg:col-span-2">
      <div class="rounded-3xl border border-gray-100 bg-white p-6 shadow-sm">
        <div class="flex flex-wrap items-center justify-between gap-3">
          <div>
            <h2 class="text-lg font-semibold text-ink">Package lineup</h2>
            <p class="text-sm text-muted">Create and manage vendor packages.</p>
          </div>
          <RouterLink to="/dashboard/add-package" class="rounded-full bg-brand px-4 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-brandDark">
            New package
          </RouterLink>
        </div>

          <div class="mt-6 overflow-hidden rounded-2xl border border-gray-100">
            <div class="grid grid-cols-5 gap-4 bg-gray-50 px-4 py-3 text-xs font-semibold uppercase tracking-wide text-muted">
            <span>Title</span>
            <span>Vendor ID</span>
            <span>Price</span>
            <span>Price per</span>
            <span></span>
          </div>
          <div class="divide-y divide-gray-100 text-sm">
            <div
              v-for="pkg in packages"
              :key="pkg.id || pkg.package_id || pkg.title"
              class="grid grid-cols-5 items-center gap-4 px-4 py-4"
            >
              <div>
                <p class="font-semibold text-ink">{{ pkg.title || 'Package' }}</p>
                <p class="text-xs text-muted">{{ pkg.description || '—' }}</p>
              </div>
              <span class="text-muted">{{ vendorId || '-' }}</span>
              <span class="text-muted">{{ formatPrice(pkg.price) }}</span>
              <span class="text-muted">{{ pkg.price_per || '-' }}</span>
              <div class="flex items-center justify-end gap-2">
                <ActionDock
                  :open-label="`Show actions for ${pkg.title || 'Package'}`"
                  :close-label="`Close actions for ${pkg.title || 'Package'}`"
                  :edit-label="`Edit ${pkg.title || 'Package'}`"
                  :delete-label="`Delete ${pkg.title || 'Package'}`"
                  :deleting="deletingPackageId === String(pkg.id || pkg.package_id)"
                  @edit="router.push(`/dashboard/edit-package/${pkg.id || pkg.package_id || ''}`)"
                  @delete="handleDelete(pkg.id || pkg.package_id)"
                />
              </div>
            </div>
            <div v-if="!packages.length" class="px-4 py-6 text-center text-sm text-muted">No packages found.</div>
          </div>
        </div>
      </div>

    </div>

    <div class="rounded-3xl border border-orange-100 bg-[#FFF7EF] p-6 shadow-sm">
      <h2 class="text-lg font-semibold text-ink">Package insights</h2>
      <div class="mt-4 space-y-4 text-sm text-muted">
        <div class="rounded-2xl border border-orange-100 bg-white p-4">
          <p class="text-xs font-semibold uppercase tracking-wide text-muted">Most requested</p>
          <p class="mt-2 text-sm font-semibold text-ink">Signature soirée</p>
          <p class="mt-2 text-xs">40% of new leads</p>
        </div>
        <div class="rounded-2xl border border-orange-100 bg-white p-4">
          <p class="text-xs font-semibold uppercase tracking-wide text-muted">Avg response time</p>
          <p class="mt-2 text-xl font-semibold text-ink">12 hrs</p>
          <p class="mt-2 text-xs">Your fastest offer yet.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { RouterLink, useRouter } from 'vue-router'
import api from '@/services/vendor/api'
import { getAuthUserId } from '@/services/auth'
import ActionDock from '@/components/vendor/ActionDock.vue'

const router = useRouter()
const packages = ref([])
const deletingPackageId = ref('')
const vendorId = getAuthUserId()

const loadPackages = async () => {
  const payload = new FormData()
  payload.append('vendor_id', vendorId)
  try {
    const { data } = await api.listVendorPackages(payload)
    packages.value = data?.list || data?.data || data?.packages || []
  } catch {
    packages.value = []
  }
}

const handleDelete = async (id) => {
  if (!id) return
  deletingPackageId.value = String(id)
  const payload = new FormData()
  payload.append('id', id)
  try {
    await api.deleteVendorPackage(payload)
    await loadPackages()
  } finally {
    deletingPackageId.value = ''
  }
}

const formatPrice = (value) => {
  if (value == null || value === '') return '-'
  const num = Number(value)
  if (Number.isNaN(num)) return value
  return num.toLocaleString()
}

onMounted(() => {
  loadPackages()
})
</script>
